module.exports = __webpack_public_path__ + "static/media/webvision5.f49c48af.png";